import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { verifyEmail } from '@/apis';
import OutlinedButton from '@/components/OutlinedButton';
import { Path } from '@/enums';
import { useApiHandler } from '@/hooks';

const VerifyEmail = () => {
  const [message, setMessage] = useState('Verifying...');
  const calledRef = useRef(false);
  const { handleApiCall } = useApiHandler();

  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    if (calledRef.current) return;
    calledRef.current = true;

    const token = params.get('token');

    if (!token) {
      setMessage('Invalid verification link');
      return;
    }

    const fn = async () => {
      const data = await handleApiCall(() => verifyEmail(token), {
        successMessage: '信箱驗證成功！',
        context: '信箱驗證',
      });
      if (data) {
        setMessage('Email verified');
      } else {
        setMessage('Verification failed');
      }
    };
    fn();
  }, [params, handleApiCall]);

  return (
    <div>
      <p>{message}</p>
      <OutlinedButton onClick={() => navigate(Path.Login)}>
        Go to Login
      </OutlinedButton>
    </div>
  );
};

export default VerifyEmail;
